export default __webpack_public_path__ + "static/media/hunnypoker-banner.12ec27a3.png";